import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const usePagination = () => {
  const history = useHistory();
  const existingFilterByEquipment = useSelector(
    state => state.plpUI.filterByEquipment
  );
  const currentCategory = useSelector(s => s.plpUI.current);
  const uniqueIndex = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.uniqueIndex
  );
  const activeFacets = useSelector(state => state.plpUI.activeFacets);
  const existingOrderBy = useSelector(state => state.plpUI.sortBy);
  const isFilterByEquipmentEnabled = useSelector(
    s => s.categories.byId[currentCategory]?.isFilterByEquipmentEnabled
  );
  const { pathname, hash } = useLocation();
  const setUrlToPageOneWithFilter = useCallback(
    (filter = {}) => {
      const {
        filterByEquipment,
        facets,
        sortBy,
        fbeEnabledValue = null,
        isMarketingPage = false,
        removeFilterByEquipment = false
      } = filter;
      const parsed = {};
      let filterByEquipmentParsed;
      if (isMarketingPage) {
        filterByEquipmentParsed =
          fbeEnabledValue && uniqueIndex
            ? filterByEquipment
            : existingFilterByEquipment;
      } else {
        filterByEquipmentParsed = uniqueIndex
          ? filterByEquipment
          : existingFilterByEquipment;
      }
      if (filterByEquipment !== undefined || facets || sortBy) {
        parsed.filterByEquipment = filterByEquipmentParsed;
        parsed.sortBy = sortBy || existingOrderBy;
        parsed.facets = ((facets ? facets : activeFacets) || []).map(
          f => f.facet
        );

        // we don't need to worry about search here since this will only be fired when going to page one.
        const urlWithHash = `${pathname}#${queryString.stringify(parsed)}`;

        history.push(urlWithHash);
      } else if (removeFilterByEquipment) {
        const { facets, orderBy } = queryString.parse(hash);
        const parsed = { facets, orderBy };
        const urlWithHash = `${pathname}#${queryString.stringify(parsed)}`;
        history.push(urlWithHash);
      } else {
        history.push(pathname);
      }
    },
    [
      activeFacets,
      existingFilterByEquipment,
      existingOrderBy,
      isFilterByEquipmentEnabled,
      history,
      pathname,
      uniqueIndex
    ]
  );

  return {
    setUrlToPageOneWithFilter
  };
};

export default usePagination;
